import React from "react";
import { motion } from "framer-motion";

import { styles } from "../styles";
import { SectionWrapper } from "../hoc";
import { blogs } from "../constants";
import { fadeIn, textVariant } from "../utils/motion";

const BlogCard = ({ index, title, readTime, category, tags, link }) => {
  const content = (
    <article className="flex h-full min-h-[300px] flex-col rounded-2xl bg-tertiary p-6 transition-colors duration-300 hover:bg-[#202043]">
      <div className="flex items-center justify-between gap-4 text-[13px] text-secondary">
        <span className="font-semibold uppercase tracking-wider text-[#56ccf2]">
          {category}
        </span>
        <span>{readTime}</span>
      </div>

      <div className="mt-6 flex flex-1 flex-col">
        <h3 className="text-[24px] font-bold leading-[32px] text-white">
          {title}
        </h3>
      </div>

      <div className="mt-6 flex flex-wrap gap-2">
        {tags.map((tag) => (
          <span
            key={tag}
            className="rounded-full border border-white/10 px-3 py-1 text-[12px] text-secondary"
          >
            {tag}
          </span>
        ))}
      </div>

    </article>
  );

  return (
    <motion.div
      variants={fadeIn("up", "spring", index * 0.1 + 0.3, 0.7)}
      className="h-full"
    >
      {link ? (
        <a href={link} target="_blank" rel="noreferrer" className="block h-full">
          {content}
        </a>
      ) : (
        content
      )}
    </motion.div>
  );
};

const Blog = () => {
  return (
    <>
      <motion.div variants={textVariant()}>
        <p className={`${styles.sectionSubText}`}>Technical notes</p>
        <h2 className={`${styles.sectionHeadText}`}>Blog.</h2>
      </motion.div>
 
      <div className="mt-10 grid grid-cols-1 gap-7 md:grid-cols-2 lg:grid-cols-3">
        {blogs.map((blog, index) => (
          <BlogCard key={blog.title} index={index} {...blog} />
        ))}
      </div>
    </>
  );
};

export default SectionWrapper(Blog, "blog");
